// src/chat/ChatWidget.js
// ویجت چت شناور — لوگوی کوچک پایین‌چپ، پاپ‌آپ ۸۰٪ صفحه، راست‌به‌چپ.
// چت هر صفحه جداست: کلید فیلتر = id تب فعال، و اگر تبی فعال نباشد = page.
//   داشبورد           → 'dashboard'
//   منوی تنظیم حساب    → 'accounting'        (ریشه)
//   سند حسابداری       → 'accounting:document'  (زیرشاخه، چت جدا)
// پس «تنظیم حساب» و «سند حسابداری» با اینکه یکی زیرشاخه‌ی دیگری است، چت مستقل دارند.

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTabs } from '../pages/TabManager';
import {
  getChatToken, getChatUser, clearChatSession,
  chatLogin, fetchMessages, postMessage, attachmentUrl,
} from './chatApi';
import { formatJalali, toFa } from './jalali';

const LOGO = require('../assets/images/arjan.png');

// برچسب فارسی صفحه‌های منو (که تب نیستند)
const SCREEN_LABELS = {
  dashboard:  'صفحه اصلی',
  accounting: 'تنظیم حساب',
};

const ACCEPT = 'image/png,image/jpeg,image/jpg,image/gif,image/webp,image/bmp';

/* ───────────────── فرم ورود چت (کامپوننت مستقل تا focus حفظ شود) ───────────────── */
function ChatLoginPanel({ onSuccess }) {
  const [u, setU]   = useState('');
  const [p, setP]   = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr]   = useState('');

  const submit = async () => {
    if (!u.trim() || !p) { setErr('نام کاربری و رمز عبور را وارد کنید.'); return; }
    setBusy(true); setErr('');
    const res = await chatLogin(u.trim(), p);
    setBusy(false);
    if (res.ok) onSuccess(res.user);
    else setErr(res.msg || 'ورود ناموفق بود.');
  };

  return (
    <div style={st.loginWrap}>
      <div style={st.loginCard}>
        <img src={LOGO} alt="" style={{ width: 48, height: 48, borderRadius: 10, marginBottom: 12 }} />
        <div style={st.loginTitle}>ورود به چت سامانه</div>
        <div style={st.loginHint}>یوزر/پسورد چت جدا از حساب برنامه است.</div>
        <input style={st.input} placeholder="نام کاربری چت" value={u}
          onChange={e => setU(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && submit()} />
        <input style={st.input} placeholder="رمز عبور" type="password" value={p}
          onChange={e => setP(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && submit()} />
        {err && <div style={st.err}>{err}</div>}
        <button style={{ ...st.primaryBtn, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submit}>
          {busy ? 'در حال ورود…' : 'ورود'}
        </button>
      </div>
    </div>
  );
}

/* ───────────────── نوار نوشتن پیام (کامپوننت مستقل) ───────────────── */
function Composer({ text, setText, files, setFiles, replyTo, clearReply, onSend, sending, msgIndex }) {
  const fileRef = useRef(null);

  const onPick = (e) => {
    const picked = Array.from(e.target.files || []);
    setFiles(prev => [...prev, ...picked]);
    e.target.value = '';
  };
  const removeFile = (idx) => setFiles(prev => prev.filter((_, i) => i !== idx));

  const parent = replyTo ? msgIndex[replyTo] : null;

  return (
    <div style={st.composer}>
      {parent && (
        <div style={st.replyBanner}>
          <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            ↩︎ در پاسخ به <b>{parent.display}</b>: {parent.body ? parent.body.slice(0, 60) : '(تصویر)'}
          </span>
          <button style={st.replyClose} onClick={clearReply}>✕</button>
        </div>
      )}

      {files.length > 0 && (
        <div style={st.previewRow}>
          {files.map((f, i) => (
            <div key={i} style={st.previewItem}>
              <img src={URL.createObjectURL(f)} alt="" style={st.previewImg} />
              <button style={st.previewRemove} onClick={() => removeFile(i)}>✕</button>
            </div>
          ))}
        </div>
      )}

      <div style={st.composerRow}>
        <button style={st.iconBtn} title="افزودن تصویر" onClick={() => fileRef.current?.click()}>🖼️</button>
        <input ref={fileRef} type="file" accept={ACCEPT} multiple
          style={{ display: 'none' }} onChange={onPick} />
        <textarea
          style={st.textarea}
          placeholder="پیام خود را بنویسید…"
          value={text}
          rows={1}
          onChange={e => setText(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); onSend(); }
          }}
        />
        <button style={{ ...st.sendBtn, opacity: sending ? 0.6 : 1 }} disabled={sending} onClick={onSend}>
          {sending ? '…' : 'ارسال'}
        </button>
      </div>
    </div>
  );
}

/* ───────────────── یک پیام ───────────────── */
function MessageItem({ m, mine, parent, onReply }) {
  return (
    <div style={{ ...st.msgRow, justifyContent: mine ? 'flex-start' : 'flex-end' }}>
      <div style={{ ...st.bubble, ...(mine ? st.bubbleMine : st.bubbleOther) }}>
        <div style={st.bubbleHead}>
          <span style={st.bubbleName}>{m.display || m.username}</span>
          <span style={st.bubbleTime}>{formatJalali(m.created_at)}</span>
        </div>

        {parent && (
          <div style={st.quoted}>
            <b>{parent.display}</b>: {parent.body ? parent.body.slice(0, 80) : '(تصویر)'}
          </div>
        )}

        {m.body && <div style={st.bubbleBody}>{m.body}</div>}

        {m.attachments && m.attachments.length > 0 && (
          <div style={st.attachGrid}>
            {m.attachments.map(a => (
              <a key={a.id} href={attachmentUrl(a.id)} target="_blank" rel="noreferrer">
                <img src={attachmentUrl(a.id)} alt={a.file_name} style={st.attachImg} />
              </a>
            ))}
          </div>
        )}

        <button style={st.replyBtn} onClick={() => onReply(m.id)}>پاسخ</button>
      </div>
    </div>
  );
}

/* ═══════════════════════════ ویجت اصلی ═══════════════════════════ */
export default function ChatWidget({ page }) {
  const { tabs, activeId } = useTabs();

  // کلید و عنوان صفحه‌ی جاری
  const screenKey = activeId || page || 'dashboard';
  const activeTab = tabs.find(t => t.id === activeId);
  const screenLabel = activeTab ? activeTab.title : (SCREEN_LABELS[page] || page);

  const [open, setOpen]         = useState(false);
  const [chatUser, setChatUser] = useState(getChatUser());
  const [messages, setMessages] = useState([]);
  const [loading, setLoading]   = useState(false);
  const [text, setText]         = useState('');
  const [files, setFiles]       = useState([]);
  const [replyTo, setReplyTo]   = useState(null);
  const [sending, setSending]   = useState(false);

  const scrollRef = useRef(null);
  const loggedIn = !!getChatToken() && !!chatUser;

  // نقشه‌ی id→پیام برای نمایش رپلای
  const msgIndex = {};
  messages.forEach(m => { msgIndex[m.id] = m; });

  const scrollToBottom = () => {
    requestAnimationFrame(() => {
      if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    });
  };

  const load = useCallback(async (silent = false) => {
    if (!getChatToken()) return;
    if (!silent) setLoading(true);
    const res = await fetchMessages(screenKey);
    if (!silent) setLoading(false);
    if (res.unauth) { clearChatSession(); setChatUser(null); return; }
    if (res.ok) {
      setMessages(prev => {
        const changed = prev.length !== res.messages.length ||
          (prev.length && prev[prev.length - 1]?.id !== res.messages[res.messages.length - 1]?.id);
        if (changed) scrollToBottom();
        return res.messages;
      });
    }
  }, [screenKey]);

  // وقتی باز شد یا صفحه عوض شد → بارگذاری مجدد (چت مخصوص همان صفحه)
  useEffect(() => {
    if (open && loggedIn) {
      setReplyTo(null);
      load();
    }
  }, [open, screenKey, loggedIn]);

  // به‌روزرسانی سبک هر ۱۲ ثانیه وقتی باز است
  useEffect(() => {
    if (!open || !loggedIn) return;
    const t = setInterval(() => load(true), 12000);
    return () => clearInterval(t);
  }, [open, screenKey, loggedIn]);

  const send = async () => {
    if (sending) return;
    if (!text.trim() && files.length === 0) return;
    setSending(true);
    const res = await postMessage({ screenKey, body: text.trim(), parentId: replyTo, files });
    setSending(false);
    if (res.unauth) { clearChatSession(); setChatUser(null); return; }
    if (res.ok) {
      setText(''); setFiles([]); setReplyTo(null);
      setMessages(prev => [...prev, res.message]);
      scrollToBottom();
    } else {
      alert(res.msg || 'ارسال ناموفق بود.');
    }
  };

  const logoutChat = () => {
    clearChatSession();
    setChatUser(null);
    setMessages([]);
  };

  return (
    <>
      {/* دکمه‌ی شناور پایین‌چپ */}
      <button style={st.fab} onClick={() => setOpen(o => !o)} title="چت سامانه">
        <img src={LOGO} alt="چت" style={st.fabLogo} />
        <span style={st.fabBadge}>💬</span>
      </button>

      {open && (
        <div style={st.overlay}>
          <div style={st.panel} dir="rtl">
            {/* هدر */}
            <div style={st.header}>
              <div style={st.headerLeft}>
                <span style={st.headerIcon}>💬</span>
                <div>
                  <div style={st.headerTitle}>چت — {screenLabel}</div>
                  <div style={st.headerSub}>
                    کلید صفحه: <span style={{ direction: 'ltr', display: 'inline-block' }}>{screenKey}</span>
                  </div>
                </div>
              </div>
              <div style={st.headerRight}>
                {loggedIn && (
                  <>
                    <span style={st.whoami}>{chatUser?.display}</span>
                    <button style={st.ghostBtn} onClick={() => load()}>تازه‌سازی</button>
                    <button style={st.ghostBtn} onClick={logoutChat}>خروج چت</button>
                  </>
                )}
                <button style={st.closeBtn} onClick={() => setOpen(false)}>✕</button>
              </div>
            </div>

            {/* بدنه */}
            {!loggedIn ? (
              <ChatLoginPanel onSuccess={u => { setChatUser(u); }} />
            ) : (
              <>
                <div style={st.messages} ref={scrollRef}>
                  {loading && messages.length === 0 && (
                    <div style={st.center}>در حال بارگذاری…</div>
                  )}
                  {!loading && messages.length === 0 && (
                    <div style={st.center}>
                      هنوز پیامی در این صفحه ثبت نشده است.<br />اولین پیام را شما بنویسید.
                    </div>
                  )}
                  {messages.map(m => (
                    <MessageItem
                      key={m.id}
                      m={m}
                      mine={chatUser && m.user_id === chatUser.id}
                      parent={m.parent_id ? msgIndex[m.parent_id] : null}
                      onReply={setReplyTo}
                    />
                  ))}
                </div>

                <Composer
                  text={text} setText={setText}
                  files={files} setFiles={setFiles}
                  replyTo={replyTo} clearReply={() => setReplyTo(null)}
                  onSend={send} sending={sending} msgIndex={msgIndex}
                />
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

/* ───────────────── استایل‌ها (هماهنگ با تم سامانه: سرمه‌ای/طلایی) ───────────────── */
const NAVY = '#0a1628', NAVY2 = '#1a2f50', GOLD = '#C8A84B';
const FONT = "'Vazirmatn',Tahoma,sans-serif";

const st = {
  fab: {
    position: 'fixed', left: 20, bottom: 20, width: 56, height: 56, borderRadius: '50%',
    background: NAVY, border: `2px solid ${GOLD}`, cursor: 'pointer', zIndex: 3000,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0,
    boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
  },
  fabLogo:  { width: 34, height: 34, borderRadius: 8 },
  fabBadge: {
    position: 'absolute', top: -4, right: -4, fontSize: 14, background: GOLD,
    width: 22, height: 22, borderRadius: '50%', display: 'flex',
    alignItems: 'center', justifyContent: 'center',
  },

  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 2999,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  panel: {
    width: '80vw', height: '80vh', background: '#f4f6fb', borderRadius: 16,
    boxShadow: '0 24px 70px rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column',
    overflow: 'hidden', fontFamily: FONT,
  },

  header: {
    background: `linear-gradient(135deg,${NAVY},${NAVY2})`, padding: '12px 18px',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    borderBottom: `2px solid ${GOLD}`,
  },
  headerLeft:  { display: 'flex', alignItems: 'center', gap: 10 },
  headerIcon:  { fontSize: 22 },
  headerTitle: { color: '#fff', fontSize: 15, fontWeight: 700 },
  headerSub:   { color: 'rgba(255,255,255,0.55)', fontSize: 11, marginTop: 2 },
  headerRight: { display: 'flex', alignItems: 'center', gap: 8 },
  whoami:      { color: GOLD, fontSize: 12, fontWeight: 700 },
  ghostBtn: {
    background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)',
    borderRadius: 7, padding: '5px 10px', cursor: 'pointer', fontSize: 12, fontFamily: FONT,
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none', width: 30, height: 30,
    borderRadius: '50%', cursor: 'pointer', fontSize: 13,
  },

  messages: { flex: 1, overflowY: 'auto', padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 10 },
  center:   { textAlign: 'center', color: '#888', fontSize: 13, margin: 'auto', lineHeight: 1.9 },

  msgRow: { display: 'flex', width: '100%' },
  bubble: {
    maxWidth: '72%', borderRadius: 14, padding: '8px 12px', position: 'relative',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
  },
  bubbleMine:  { background: '#dceeff', borderTopRightRadius: 4 },
  bubbleOther: { background: '#fff', borderTopLeftRadius: 4 },
  bubbleHead:  { display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'center', marginBottom: 4 },
  bubbleName:  { fontSize: 12, fontWeight: 700, color: NAVY2 },
  bubbleTime:  { fontSize: 10, color: '#999' },
  bubbleBody:  { fontSize: 13, color: '#222', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.8 },
  quoted: {
    borderRight: `3px solid ${GOLD}`, background: 'rgba(0,0,0,0.04)', padding: '4px 8px',
    borderRadius: 6, fontSize: 11, color: '#555', marginBottom: 6,
  },
  attachGrid: { display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 6 },
  attachImg:  { width: 120, height: 120, objectFit: 'cover', borderRadius: 8, cursor: 'pointer', border: '1px solid #ddd' },
  replyBtn: {
    marginTop: 6, background: 'transparent', border: 'none', color: GOLD, cursor: 'pointer',
    fontSize: 11, fontFamily: FONT, padding: 0, fontWeight: 700,
  },

  composer: { borderTop: '1px solid #e3e6ee', background: '#fff', padding: 10 },
  replyBanner: {
    display: 'flex', alignItems: 'center', gap: 8, background: '#f0f3fa',
    borderRadius: 8, padding: '6px 10px', fontSize: 12, color: '#555', marginBottom: 8,
  },
  replyClose: { background: 'transparent', border: 'none', cursor: 'pointer', color: '#888', fontSize: 12 },
  previewRow:  { display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' },
  previewItem: { position: 'relative' },
  previewImg:  { width: 60, height: 60, objectFit: 'cover', borderRadius: 8, border: '1px solid #ddd' },
  previewRemove: {
    position: 'absolute', top: -6, left: -6, background: '#c62828', color: '#fff', border: 'none',
    width: 18, height: 18, borderRadius: '50%', cursor: 'pointer', fontSize: 10,
  },
  composerRow: { display: 'flex', alignItems: 'flex-end', gap: 8 },
  iconBtn: {
    background: '#eef1f8', border: '1px solid #d8deea', borderRadius: 10, width: 40, height: 40,
    cursor: 'pointer', fontSize: 18, flexShrink: 0,
  },
  textarea: {
    flex: 1, resize: 'none', minHeight: 40, maxHeight: 120, padding: '10px 12px',
    border: '1px solid #d8deea', borderRadius: 10, fontFamily: FONT, fontSize: 13,
    direction: 'rtl', lineHeight: 1.8, outline: 'none',
  },
  sendBtn: {
    background: NAVY, color: '#fff', border: `1px solid ${GOLD}`, borderRadius: 10,
    padding: '0 18px', height: 40, cursor: 'pointer', fontFamily: FONT, fontSize: 13,
    fontWeight: 700, flexShrink: 0,
  },

  loginWrap: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  loginCard: {
    background: '#fff', borderRadius: 16, padding: '28px 26px', width: 320, textAlign: 'center',
    boxShadow: '0 8px 30px rgba(0,0,0,0.12)', display: 'flex', flexDirection: 'column', alignItems: 'center',
  },
  loginTitle: { fontSize: 16, fontWeight: 800, color: NAVY2, marginBottom: 4 },
  loginHint:  { fontSize: 11, color: '#999', marginBottom: 16 },
  input: {
    width: '100%', padding: '10px 12px', border: '1px solid #d8deea', borderRadius: 10,
    fontFamily: FONT, fontSize: 13, marginBottom: 10, direction: 'rtl', outline: 'none', boxSizing: 'border-box',
  },
  err: { color: '#c62828', fontSize: 12, marginBottom: 8 },
  primaryBtn: {
    width: '100%', background: NAVY, color: '#fff', border: `1px solid ${GOLD}`, borderRadius: 10,
    padding: '11px 0', cursor: 'pointer', fontFamily: FONT, fontSize: 14, fontWeight: 700, marginTop: 4,
  },
};
